<!-- 业务流程 -->
<template>
  <div class="process">
    <h3 class="h3">{{processData[0].title}}</h3>
    <div class="processCon width">
      <div class="processConItem" v-for="(item,i) in processData[0].child" :key="i">
        <div class="title">
          <p v-for="(item1,i1) in processData[0].child[i].title" :key="i1">{{item1.title}}</p>
        </div>
        <img :src="item.img" alt srcset />
        <div class="p">
          <p>{{item.p}}</p>
        </div>
        <i class="el-icon-caret-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      processData: [
        {
          title: '业务流程',
          child: [
            {
              title: [{ title: '提交方案咨询' }],
              img: require('../assets/images/u1327.png'),
              p: '点击提交方案咨询订单',
            },
            {
              title: [{ title: '订单审核' }],
              img: require('../assets/images/u1294.png'),
              p: '售前联系确认审核订单有效性',
            },
            {
              title: [{ title: '签订合同' }],
              img: require('../assets/images/u1300.png'),
              p: '电子合同签订',
            },
            {
              title: [{ title: '支付预付款' }],
              img: require('../assets/images/u1306.png'),
              p: '根据合同要求支付订单预付金额',
            },
            {
              title: [{ title: '寄送样品' }, { title: '样品评估' }],
              img: require('../assets/images/u1312.png'),
              p: '寄送样品进行样品检测',
            },
            {
              title: [
                { title: '出具报告' },
                { title: '报告寄送' },
                { title: '支付尾款' },
              ],
              img: require('../assets/images/u1318.png'),
              p: '报告结果寄送',
            },
            {
              title: [{ title: '售后服务' }],
              img: require('../assets/images/u1324.png'),
              p: '平台售后咨询和售后服务',
            },
          ],
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.process {
  width: 100%;
  padding-bottom: 40px;
  margin-bottom: 10px;
  padding-top: 20px;
  margin-top: 10px;
  background: url('../assets/images/u861.png') 100% 100% no-repeat;
  background-size: cover;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    padding-bottom: 10px;
    color: #fff;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .processCon {
    display: flex;
    .processConItem {
      position: relative;
      flex: 1;
      margin: 0 40px 0 0;
      padding: 0 10px;
      text-align: center;
      background-color: rgba(242, 242, 242, 1);
      border-radius: 4px;

      .title {
        height: 60px;
        margin-top: 16px;
        p {
          font-size: 16px;
          margin: 0;

          line-height: 20px;
        }
      }
      p {
        color: #2b8df9;
      }
      img {
        width: 58px;
      }

      .el-icon-caret-right {
        position: absolute;
        right: -32px;
        top: 50%;
        margin-top: -30px;
        font-size: 60px;
        color: rgba(242, 242, 242, 1);
      }
    }
    .processConItem:first-child {
      background-color: rgba(50, 168, 255, 1);
      p {
        color: #fff;
      }
      .el-icon-caret-right {
        color: rgba(50, 168, 255, 1);
      }
    }
    .processConItem:last-child {
      margin-right: 0;
    }
  }
}
</style>
